import AlertIcon from "./AlertIcon";

function Alert({title, children}) {
    return (
        <div
          className="bg-yellow-50 border border-yellow-200 text-sm text-yellow-800 rounded-lg p-4"
          role="alert"
        >
          <div className="flex">
            <div className="flex-shrink-0">
              <AlertIcon />
            </div>
            <div className="ms-4">
              <h3 className="text-base font-semibold">
                {title}
              </h3>
              <div className="mt-1 leading-6 text-base text-yellow-700 leading-6">
                {children}
              </div>
            </div>
          </div>
        </div>
    )
}

export default Alert;